import { makeStyles } from '@material-ui/styles';

export const useActionStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    padding: theme.spacing(2)
  }
}));

export const useActionTaskAllocationFFOnStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: theme.spacing(2)
  }
}));

export const useContentStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    minWidth: 550,
    minHeight: 350
  }
}));

export const useContentTaskAllocationFFOnStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    width: theme.spacing(67.5),
    height: theme.spacing(31.25)
  }
}));

export const useSpinnerStyles = makeStyles(theme => ({
  progress: {
    left: '50%',
    position: 'absolute',
    bottom: '50%'
  },
  spinner: {
    marginRight: theme.spacing(3),
    color: theme.palette.text.disabled
  }
}));
